import ReactDOM from 'react-dom'

const AlertMessage = ({status, open, text, location}) => {
    return open ?
    ReactDOM.createPortal(
        <div className={'alert '+ status}>
			<div>{text}</div>
        </div>
        , document.getElementById(location)
    )
    : null
}

export default AlertMessage;
